import { defineNuxtPlugin } from "#app";
import Cookies from "universal-cookie"

export default defineNuxtPlugin((nuxtApp) => {
    const cookies = new Cookies(nuxtApp.ssrContext?.req?.headers?.cookie);
    nuxtApp.provide("cookies", cookies)
})